import { BaseService } from "@js/filesfromccqbase/BaseService";
import { BroadcastService } from "@js/filesfromccqbase/BroadcastService";
import {
  CommercialDeal,
  SaveCommercialSearchRequest,
  UpdateCommercialSearchGetResultRequest,
  UpdateCommercialSearchGetResultResponse,
} from "@src/apis/ModularClient";

export class CommercialDealService extends BaseService<CommercialDeal, number> {
  static $inject = ["$http", "$cookies", "$rootScope", "$q", "$timeout", "BroadcastService"];

  constructor(
    http: ng.IHttpService,
    cookies: ng.cookies.ICookiesService,
    rootScope: ng.IRootScopeService,
    q: ng.IQService,
    timeout: ng.ITimeoutService,
    broadcastservice: BroadcastService,
  ) {
    super(http, cookies, rootScope, q, timeout, broadcastservice);
    this.$baseAddress = "/api/commercialdeal";
    this.$broadcastBusinessNameSingular = "commercialdeal";
    this.$broadcastBusinessNamePlural = this.$broadcastBusinessNameSingular + "s";
    this.$broadcastScreen = this.$broadcastBusinessNamePlural;
  }

  debugSearch(dealDto: CommercialDeal): ng.IPromise<[]> {
    let defer = this.$q.defer<[]>();
    this.$http
      .get(this.$baseAddress + "/debugSearch")
      .then((response) => {
        defer.resolve(response.data as []);
      })
      .catch((response) => {
        defer.reject(response);
      });
    return defer.promise;
  }
}
